/*
 *		Copyright (c) 2011-2014 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

angular.module('access.Navigation')
    .directive('accQuotaInfo', ['$timeout', function($timeout){
    var appearTimeout;

    return {
        link: function(scope, elem) {

            elem.hover(function(){
                appearTimeout = $timeout(function() {
                    scope.quotaInfo.show();
                }, 100);
            }, function(){
                $timeout.cancel(appearTimeout);
                scope.quotaInfo.hide();
                scope.$apply();
            });

        }
    }
}]);